import React, { useState } from 'react';
import { Row, Col } from 'antd';
import useGlobal from '../../../store/Store';
import { Results } from '../../../common/results/Results';
import { PropertySettings } from '../../../common/results/PropertySettings';
import { AnnotationSettings } from '../../../common/results/AnnotationSettings';
import { Label } from '../../../types/label';
import { DatasetFileVersion } from '../../../types/dataset';
import { Section } from '../../../components/Section';

type Props = {
  datasetFileVersion: DatasetFileVersion | null;
  onAnnotationChange: (labels: Label[]) => any;
  onPropertiesChange?: (properties: {}) => any;
};

const ResultSideBar = (props: Props) => {
  const { datasetFileVersion, onAnnotationChange, onPropertiesChange } = props;

  const [globalState, globalActions] = useGlobal();
  const [showShortcuts, setShowShortcuts] = useState<boolean>(true);

  const onAccept = (label: Label) => {
    const labels = globalActions.acceptLabel(label);
    onAnnotationChange(labels);
  };

  const onDelete = (label: Label) => {
    globalActions.addToLabelHistory(label);
    const labels = globalActions.removeLabel(label);
    onAnnotationChange(labels);
  };

  const onPropertyChange = (properties: {}) => {
    globalActions.setProperties(properties);
    if (onPropertiesChange) onPropertiesChange(properties);
  };

  const onEdit = (label: Label) => {
    if (globalState.labelEdit && globalState.labelEdit.id === label.id) {
      globalActions.setLabelEdit(null);
      if (globalState.labelEditCopied) {
        globalActions.removeLabel(label);
        globalActions.setLabelEditCopied(false);
      }
    } else {
      const prevLabel = globalState.labelEdit;
      if (globalState.labelEditCopied && prevLabel) {
        globalActions.removeLabel(prevLabel);
        globalActions.setLabelEditCopied(false);
      }
      globalActions.setLabelEdit(label);
    }
  };

  return (
    <>
      <Row>
        {datasetFileVersion ? (
          <Col span={24}>
            {globalState.properties && (
              <Section>
                <PropertySettings onPropertyChange={onPropertyChange} />
              </Section>
            )}
            <Section>
              <AnnotationSettings showShortcuts={showShortcuts} setShowShortcuts={setShowShortcuts} />
            </Section>
            <Results
              onAccept={onAccept}
              onDelete={onDelete}
              onEdit={onEdit}
              datasetMode={true}
              beautifyLabels={false}
              showShortcuts={showShortcuts}
              inTable={false}
            />
          </Col>
        ) : (
          <Section>
            <span>No file selected</span>
          </Section>
        )}
      </Row>
    </>
  );
};

export default ResultSideBar;
